export const toBase64 = (text: string): string => {
  const bytes = new TextEncoder().encode(text);
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary);
};

export const toBase64Url = (text: string): string =>
  toBase64(text).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
